import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=013f2da5&scoped=true&"
import script from "./phone-input.vue?vue&type=script&lang=js&"
export * from "./phone-input.vue?vue&type=script&lang=js&"
import style0 from "./phone-input.vue?vue&type=style&index=0&id=013f2da5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f2da5",
  null
  
)

export default component.exports